import { render, staticRenderFns } from "./TeacherDetailDialog.vue?vue&type=template&id=40a55880&scoped=true&"
import script from "./TeacherDetailDialog.vue?vue&type=script&lang=js&"
export * from "./TeacherDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./TeacherDetailDialog.vue?vue&type=style&index=0&id=40a55880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a55880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
